import axios from 'axios';

const baseUrl = "https://api.oonksa.com/";
// const baseUrl = 'https://legal-api.faimsoft.com/';

const apiUrl = {
  baseUrl: `${baseUrl}`,
  login: `${baseUrl}auth/sign-in/`,
  sendResetEmail: `${baseUrl}auth/reset-send-email/`,
  verifyOtp: `${baseUrl}auth/verify-email-otp/`,
  resetPassword: `${baseUrl}auth/reset-password-email/`,
  signUp:`${baseUrl}auth/sign-up/`,

  // login: 'auth/secure/sign-in/',
  // sendEmail: 'auth/secure/reset-send-email/',
  // verifyOTP: 'auth/secure/verify-email-otp/',
  // resetPassword: 'auth/secure/reset-password/',
  // checkEmail: 'auth/secure/check-email/',
  // checkMobile: 'auth/secure/check-mobile/',


  faqUrl:`${baseUrl}core/faqs/`,
  specializations:`${baseUrl}core/specializations/`,
  subSpecializations:`${baseUrl}core/categories/`,
  specializationsDetails:`${baseUrl}core/specializations/`,
  consultations:`${baseUrl}workflow/consultations/`,
  subSpecializationsList:`${baseUrl}core/categories/?specialization=`,
  
  sendResetEmail: `${baseUrl}auth/reset-send-email/`,
  verifyOtp: `${baseUrl}auth/verify-email-otp/`,
  // resetPassword: `${baseUrl}auth/reset-password-email/`,
  resetPassword: `${baseUrl}auth/reset-password/`,
  imgUrl:`${baseUrl}accounts`,
  check_mobile:`${baseUrl}auth/check-mobile/`,
  

  // user Account
  profileUrl:`${baseUrl}accounts/profile/`,
  account_Update:`${baseUrl}accounts/update-account/`,
  lawyer_Profile:`${baseUrl}accounts/lawyer-profile/`,
  AdminStaff:`${baseUrl}accounts/admin-staff-profile/`,

  // lawyer 
  lawyerUrl:`${baseUrl}manage/lawyers/`,
  ActiveLawyer:`${baseUrl}manage/lawyers/`,
  searchLawyer:`${baseUrl}manage/lawyers/?`,

  // banner 
  bannerApi:`${baseUrl}core/banners/`,
cahtHistoryApi:`${baseUrl}messaging/chat/history/`,
 casesUrl: `${baseUrl}workflow/cases/`,
  searchCases: `${baseUrl}workflow/cases/search/`,
  // dashboard
  dashboardApi:`${baseUrl}workflow/dashboard/`,

  // notifications
  notificationsApi:`${baseUrl}core/notifications/`,

  // adminStaff
  adminStaffApi : `${baseUrl}manage/staff/`,

  // clients
  clientApi : `${baseUrl}manage/clients/`,
  delete_account : `${baseUrl}accounts/delete-account/`,

  // city api
  cityApi :`${baseUrl}core/cities/`,
  fileAttachmentApi : `${baseUrl}messaging/files/`,
};

const role = sessionStorage.getItem('role');

export { baseUrl, apiUrl };

export function apiCallUnsecureGet(api, response, error) {
  console.log('apiCallSecureGet ', api);
  axios
    .get(api)
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        console.log(`Error 1 >> ${err.response.data.msg} `);
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(`Error 2 >> ${err.request} `);
        error(err.request);
      } else {
        console.log('Error 3 >>', err.message);
        error(`Error >> ${err.message} `);
      }
      console.log(err.config);
      error(`Error 4 >> ${err.message} `);
    });
}
const accessToken = sessionStorage.getItem('accessToken') || '';
export function apiCallSecureGet(api, response, error) {
  console.log('apiCallSecureGet ', api);
  console.log('token ', `Token ${accessToken} `);
  axios
    .get(api, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        console.log(`Error 1 >> ${err.response.data.msg} `);
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(`Error 2 >> ${err.request} `);
        error(err.request);
      } else {
        console.log('Error 3 >>', err.message);
        error(`Error >> ${err.message} `);
      }
      console.log(err.config);
      error(`Error 4 >> ${err.message} `);
    });
}

export function apiCallPostWithForm(api, form, response, error) {
  console.log('uploadFile ', api);

  axios
    .post(api, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken} `
      }
    })
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log(err.config);
    });
}

export function apiCallPutWithForm(api, form, response, error) {
  console.log('uploadFile ', api);

  axios
    .put(api, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Token ${accessToken} `
      }
    })
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log('Error', err.response);
    });
}

export function uploadFile(api, name, file, response, error) {
  console.log('uploadFile ', api);
  console.log(name, file.name);

  const formData = new FormData();
  formData.append(name, file);
  axios
    .post(api, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Token ${accessToken} `
      }
    })
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log(err.config);
    });
}

export function apiCallPostFormData(api, formData, response, error) {
  console.log('apiCallPostFormData ', api);

  axios
    .post(api, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Token ${accessToken} `
      }
    })
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log(err.config);
    });
}

export function apiCallSecureDelete(api, id, response, error) {
  const url = `${api}?id = ${id} `;
  console.log('apiCallSecureDelete ', url);
  axios
    .delete(url, {
      headers: {
        Authorization: `Token ${accessToken} `
      }
    })
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log(err.config);
    });
}

export function apiPostUnsecure(api, data, response, error) {
  console.log('apiPostUnsecure ', api, 'data ', data);

  axios
    .post(api, data)
    .then((res) => {
      console.warn('result', res);

      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log(err.config);
    });
}

export function apiPostSecure(api, data, response, onError) {
  console.log('apiPostSecure ', api, 'data ', data);

  axios
    .post(api, data, {
      headers: {
        Authorization: `Bearer ${accessToken} `
      }
    })
    .then((res) => {
      console.log('result', res.data);

      const result = res.data;

      if (result.code === 200) {
        response(result);
      } else {
        onError(result.msg);
      }
    })
    .catch((err) => {
      try {
        console.log('error', err.response);

        if (err.response) {
          onError(err.response.data.msg);
        } else if (err.request) {
          console.log(err.request);
          onError(err.request);
        } else {
          console.log('Error', err.message);
          onError(`Error ${err.message} `);
        }
      } catch (e) {
        console.log(e);
        onError('Something went wrong!');
      }
      console.log(err.config);
    });
}

export function apiPutSecure(api, data, response, error) {
  console.log('apiPutSecure ', api, 'data ', data);

  axios
    .put(api, data, {
      headers: {
        Authorization: `Bearer ${accessToken} `
      }
    })
    .then((res) => {
      console.warn('result', res);

      const result = res.data;

      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log(err.config);
    });
}

export async function apiCallSecureDeleteUrl(api, response, error) {
  axios
    .delete(api, {
      headers: {
        Authorization: `Token ${accessToken} `
      }
    })
    .then((res) => {
      console.warn('result', res);
      const result = res.data;
      if (result.code === 200) {
        response(result);
      } else {
        error(result.msg);
      }
    })
    .catch((err) => {
      if (err.response) {
        error(err.response.data.msg);
      } else if (err.request) {
        console.log(err.request);
        error(err.request);
      } else {
        console.log('Error', err.message);
        error(`Error ${err.message} `);
      }
      console.log(err.config);
    });
}

export function apiDeleteSecureWithoutURL(api, data, response, onError) {
  console.log('apiDeleteSecureWithoutURL ', api, 'data ', data);
  const token = accessToken;
  console.log('token api', token);

  axios
    .delete(api, {
      headers: {
        Authorization: `Bearer ${token} `,
        'Content-Type': 'application/json'
      },
      data: data
    })
    .then((res) => {
      console.log('result', res.data);

      const result = res.data;

      if (result.code === 200) {
        response(result);
      } else {
        onError(result.msg);
      }
    })
    .catch((err) => {
      try {
        console.log('error', err.response);

        if (err.response) {
          onError(err.response.data.msg);
        } else if (err.request) {
          console.log(err.request);
          onError(err.request);
        } else {
          console.log('Error', err.message);
          onError(`Error ${err.message} `);
        }
      } catch (e) {
        console.log(e);
        onError('Something went wrong!');
      }
      console.log(err.config);
    });
}

export default apiCallUnsecureGet;
//
export function apiCallSecureGetWithBody(api, data, response, onError) {
  console.log('apiGetSecure URL:', api);
  console.log('apiGetSecure Data:', data);

  axios
    .get(api, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json' // Set content type for the body
      },
      data: data // Attach data to the request body
    })
    .then((res) => {
      console.log('result', res.data);

      const result = res.data;

      if (result.code === 200) {
        response(result);
      } else {
        onError(result.msg);
      }
    })
    .catch((err) => {
      try {
        console.log('error', err.response);

        if (err.response) {
          onError(err.response.data.msg);
        } else if (err.request) {
          console.log(err.request);
          onError(err.request);
        } else {
          console.log('Error', err.message);
          onError(`Error ${err.message}`);
        }
      } catch (e) {
        console.log(e);
        onError('Something went wrong!');
      }
      console.log(err.config);
    });
}
